import Link from 'next/link';

import { FeaturedCollectionsTrackPromotionEvent } from '@/common/analytics/gtm/Homepage/featuredCollectionsAnalytics';
import { trackElementInteraction } from '@/common/analytics/gtm/shared/trackElementInteraction';
import { trackG4ViewPromotion } from '@/common/analytics/gtm/shared/trackViewPromotion';
import PillsPicker from '@/common/components/PillsPicker/PillsPicker';
import { ImpressionsContextProvider } from '@/common/impressions';
import { Button } from '@/common/styleguide/atoms/Button/Button';
import { RouteToBrowseBrandsPage } from '@/modules/BrowseBrands/BrowseBrandsConfig';
import { RouteToBrowseCollectionsPage } from '@/modules/BrowseCollectionsPage/BrowseCollectionsPageConfig';
import {
  FeaturedCollectionsOptionValues,
  featuredCollectionsOptions,
} from '@/modules/HomePage/components/FeaturedCollections/FeaturedCollections';
import { HomepageFeaturedCollection } from 'generatedBfw/static';

import CollectionsSlider from './CollectionsSlider/CollectionsSlider';
import styles from './featuredCollections.module.scss';

interface Props {
  currentCollections: HomepageFeaturedCollection[];
  activeOption: FeaturedCollectionsOptionValues;
  handleChangeOption: (selectedOption: FeaturedCollectionsOptionValues) => void;
}

const FeaturedCollectionsView = ({
  currentCollections,
  activeOption,
  handleChangeOption,
}: Props) => {
  return (
    <section className={styles.container} data-testid="featured-collections">
      <h2 className={styles.heading}>Popular collections this&nbsp;week</h2>
      <PillsPicker
        activeOption={activeOption}
        className={styles.pills}
        onChange={handleChangeOption}
        options={featuredCollectionsOptions}
      />
      <ImpressionsContextProvider<FeaturedCollectionsTrackPromotionEvent>
        callback={trackG4ViewPromotion}
        shouldSendSeparately
      >
        <CollectionsSlider collections={currentCollections} />
      </ImpressionsContextProvider>
      <div className={styles.separator}>
        {activeOption === 'brands' ? (
          <Button
            as={Link}
            className={styles.button}
            data-testid="featured-collections-button"
            href={RouteToBrowseBrandsPage().route}
            onClick={() => {
              trackElementInteraction({ elementId: 'see_all_brands_button' });
            }}
            variant="secondary"
          >
            See all Brands
          </Button>
        ) : (
          <Button
            as={Link}
            className={styles.button}
            data-testid="featured-collections-button"
            href={RouteToBrowseCollectionsPage().route}
            onClick={() => {
              trackElementInteraction({ elementId: 'browse_more_artists_button' });
            }}
            variant="secondary"
          >
            Browse more
          </Button>
        )}
      </div>
    </section>
  );
};

export default FeaturedCollectionsView;
